/**
 * Where a storey's floor art actually covers its cells. Every piece of the floors tileset stops
 * FLOOR_RIM_INSET short of a side it shares with a cell that has no floor (tucked under a wall, or
 * the rim of a hole), and is notched FLOOR_RIM_INSET square at a corner whose diagonal neighbour has
 * none -- measured on all 28 pieces HouseBuilder draws (house.ts). So an opening in a floor shows as
 * its cells widened by the inset wherever the floor runs up to it: one missing cell is a 56px hole.
 */
export const FLOOR_RIM_INSET = 12

const T = 32

export interface FloorRect { x0: number; y0: number; x1: number; y1: number }

/**
 * The parts of floor cell (x, y) its art covers, in the storey's pixels: the whole cell when every
 * neighbour has floor, otherwise up to three bands (the top rim strip, the middle, the bottom rim strip).
 */
export const drawnFloorRects = (x: number, y: number, hasFloor: (x: number, y: number) => boolean): FloorRect[] => {
    const n = hasFloor(x, y - 1), s = hasFloor(x, y + 1), w = hasFloor(x - 1, y), e = hasFloor(x + 1, y)
    const nw = hasFloor(x - 1, y - 1), ne = hasFloor(x + 1, y - 1), sw = hasFloor(x - 1, y + 1), se = hasFloor(x + 1, y + 1)
    const left = x * T, right = left + T, top = y * T, bottom = top + T, I = FLOOR_RIM_INSET
    if (n && s && w && e && nw && ne && sw && se) return [{ x0: left, y0: top, x1: right, y1: bottom }]
    const bands: FloorRect[] = []
    const band = (y0: number, y1: number, west: boolean, east: boolean) => {
        const rect = { x0: west ? left : left + I, y0, x1: east ? right : right - I, y1 }
        const above = bands[bands.length - 1]
        if (above && above.x0 === rect.x0 && above.x1 === rect.x1 && above.y1 === y0) above.y1 = y1
        else bands.push(rect)
    }
    if (n) band(top, top + I, w && nw, e && ne)
    band(top + I, bottom - I, w, e)
    if (s) band(bottom - I, bottom, w && sw, e && se)
    return bands
}
